/**
 * Employee Card Component
 * Handles showing/hiding employee contact details on hover (desktop) or click (mobile)
 */
const Employee = (domEl) => {
	// Elements
	const button = domEl.querySelector('.read-more-button');
	const content = domEl.querySelector('.post-content');
	const icon = button ? button.querySelector('.icon') : null;

	// State
	let isOpen = false;
	let timeout;

	// Methods
	const showContent = () => {
		if(!content) {
			return;
		}

		// Cancel any pending hide
		clearTimeout(timeout);

		// Add a class that preserves padding during animation
		domEl.classList.add('content-animating');

		// Set display flex first (without changing the box model yet)
		content.style.display = 'flex';
		content.style.opacity = '1';
		content.setAttribute('aria-expanded', true);

		// Force a reflow before setting height
		void content.offsetHeight;

		// Set height and rotate the arrow
		setTimeout(() => {
			content.style.height = content.scrollHeight + 'px';
			if(icon) {
				icon.style.rotate = '90deg';
			}
			if(button) {
				button.classList.add('active');
			}
			isOpen = true;
		}, 10);
	};

	const hideContent = () => {
		if(!content) {
			return;
		}

		// Set height to 0 and fade out
		content.style.height = '0';
		content.style.opacity = '0';
		content.setAttribute('aria-expanded', false);

		// Reset arrow rotation
		if (icon) {
			icon.style.rotate = '0deg';
		}
		if (button) {
			button.classList.remove('active');
		}

		isOpen = false;

		// Wait for transition before setting display none
		timeout = setTimeout(() => {
			if (!isOpen) { // Double-check state hasn't changed
				content.style.display = 'none';
				domEl.classList.remove('content-animating');
			}
		}, 300); // Match transition duration
	};

	const toggleContent = () => {
		if (isOpen) {
			hideContent();
		} else {
			showContent();
		}
	};

	const updateHeight = () => {
		if (isOpen && content) {
			// Temporarily remove transition
			const currentTransition = content.style.transition;
			content.style.transition = 'none';

			// Update height to match new scrollHeight
			content.style.height = 'auto';
			const newHeight = content.scrollHeight;
			content.style.height = newHeight + 'px';

			// Force reflow
			void content.offsetHeight;

			// Restore transition
			content.style.transition = currentTransition;
		}
	};

	// Initialize
	const init = () => {
		if (!content || !button) return;

		// Set initial styles for animation
		content.style.display = 'none';
		content.style.height = '0';
		content.style.overflow = 'hidden';
		content.style.transition = 'height 0.3s ease-out';

		button.addEventListener('click', (e) => {
			e.preventDefault();
			toggleContent();
		});

		// Handle window resize
		window.addEventListener('resize', updateHeight);
	};

	// Clean up event listeners when needed
	const destroy = () => {
		if (button) {
			button.removeEventListener('click', toggleContent);
		}

		domEl.removeEventListener('mouseenter', showContent);
		domEl.removeEventListener('mouseleave', hideContent);
	};

	// Initialize the component
	init();

	// Return public methods
	return {
		open: showContent,
		close: hideContent,
		toggle: toggleContent,
		destroy
	};
};

export default Employee;